import useStore from "../../store"
import { useEffect } from "react"
import DashboardContainer from "../common/DashboardContainer"
import RegisterBiometric from "../RegisterBiometric/RegisterBiometric"
import VCIDealers from "./Dealers/VCIDealers"

export default function VCIDashboard() {
  const askRegisterBiometric = useStore((state) => state.askRegisterBiometric)
  const user = useStore((state) => state.user)
  const fetchDealers = useStore((state) => state.fetchDealers)
  const dealerFilterAttribute = useStore((state) => state.dealerFilterAttribute)
  const dealersPage = useStore((state) => state.dealersPage)
  const setUserLocation = useStore((state) => state.setUserLocation)

  useEffect(() => {
    fetchDealers({})
    if(navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setUserLocation({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        })
      })
    }
  }, [dealerFilterAttribute, dealersPage])

  const sidePanels = []

  return(
    <DashboardContainer sidePanels={sidePanels}>
      {askRegisterBiometric && user.type === 'DealerUser' && <RegisterBiometric />}
      <VCIDealers />
    </DashboardContainer>
  )
}